export enum AreaCapabilityType {
  DockOperation = 'DockOperation',
  TripPlanning = 'TripPlanning',
  QueueManagement = 'QueueManagement',
  TaktTracking = 'TaktTracking',
  SensorIntegration = 'SensorIntegration',
  FiscoIntegration = 'FiscoIntegration',
  ETransportIntegration = 'ETransportIntegration',
  ManualTripLink = 'ManualTripLink',
  PackingOperation = 'PackingOperation',
  MilkRunOperation = 'MilkRunOperation',
}
